import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderEligibilityBatch: build.mutation<
      PostV2ProviderEligibilityBatchApiResponse,
      PostV2ProviderEligibilityBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/batch`,
        method: "POST",
        body: queryArg.batchCheckRequest,
      }),
    }),
    getV2ProviderEligibilityBatchByBatchId: build.query<
      GetV2ProviderEligibilityBatchByBatchIdApiResponse,
      GetV2ProviderEligibilityBatchByBatchIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/batch/${queryArg.batchId}`,
      }),
    }),
    postV2ProviderEligibilityChecksBatch: build.mutation<
      PostV2ProviderEligibilityChecksBatchApiResponse,
      PostV2ProviderEligibilityChecksBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/checks/batch`,
        method: "POST",
        body: queryArg.bulkCheckRequest,
      }),
    }),
    getV2ProviderEligibilityWorklist: build.query<
      GetV2ProviderEligibilityWorklistApiResponse,
      GetV2ProviderEligibilityWorklistApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/worklist`,
        params: {
          days: queryArg.days,
          include_silenced: queryArg.includeSilenced,
          segment: queryArg.segment,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderEncountersByEncounterIdEligibility: build.query<
      GetV2ProviderEncountersByEncounterIdEligibilityApiResponse,
      GetV2ProviderEncountersByEncounterIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/eligibility`,
      }),
    }),
    postV2ProviderEncountersByEncounterIdEligibility: build.mutation<
      PostV2ProviderEncountersByEncounterIdEligibilityApiResponse,
      PostV2ProviderEncountersByEncounterIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/eligibility`,
        method: "POST",
      }),
    }),
    postV2ProviderEncountersByEncounterIdEligibilityVerifications:
      build.mutation<
        PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiResponse,
        PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/encounters/${queryArg.encounterId}/eligibility/verifications`,
          method: "POST",
          body: queryArg.manualUpdateRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdEligibility: build.query<
      GetV2ProviderPatientsByPatientIdEligibilityApiResponse,
      GetV2ProviderPatientsByPatientIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility`,
      }),
    }),
    postV2ProviderPatientsByPatientIdEligibility: build.mutation<
      PostV2ProviderPatientsByPatientIdEligibilityApiResponse,
      PostV2ProviderPatientsByPatientIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility`,
        method: "POST",
      }),
    }),
    deleteV2ProviderPatientsByPatientIdEligibilityDisposition: build.mutation<
      DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiResponse,
      DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility/disposition`,
        method: "DELETE",
      }),
    }),
    postV2ProviderPatientsByPatientIdEligibilityDispositionDismiss:
      build.mutation<
        PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiResponse,
        PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/eligibility/disposition/dismiss`,
          method: "POST",
        }),
      }),
    postV2ProviderPatientsByPatientIdEligibilityDispositionSnooze:
      build.mutation<
        PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiResponse,
        PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/eligibility/disposition/snooze`,
          method: "POST",
          body: queryArg.snoozeAlertsRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdEligibilityVerifications: build.query<
      GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse,
      GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility/verifications`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2ProviderPatientsByPatientIdEligibilityVerifications: build.mutation<
      PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse,
      PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility/verifications`,
        method: "POST",
        body: queryArg.manualUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderEligibilityBatchApiResponse =
  /** status 200 OK */ BatchCheckResponse;
export type PostV2ProviderEligibilityBatchApiArg = {
  batchCheckRequest: BatchCheckRequest;
};
export type GetV2ProviderEligibilityBatchByBatchIdApiResponse =
  /** status 200 OK */ BatchProgressResponse;
export type GetV2ProviderEligibilityBatchByBatchIdApiArg = {
  batchId: string;
};
export type PostV2ProviderEligibilityChecksBatchApiResponse =
  /** status 200 OK */ BulkCheckResponse;
export type PostV2ProviderEligibilityChecksBatchApiArg = {
  bulkCheckRequest: BulkCheckRequest;
};
export type GetV2ProviderEligibilityWorklistApiResponse =
  /** status 200 OK */ WorklistResponse;
export type GetV2ProviderEligibilityWorklistApiArg = {
  days?: number;
  includeSilenced?: boolean;
  /** Filter items to a single segment bucket. ``silenced`` requires ``include_silenced=true``. Invalid values return 422. */
  segment?:
    | (
        | "all"
        | "needs_now"
        | "collect"
        | "needs_coverage"
        | "awaiting_check"
        | "info"
        | "verified"
        | "silenced"
      )
    | null;
  page?: number;
  perPage?: number;
};
export type GetV2ProviderEncountersByEncounterIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type GetV2ProviderEncountersByEncounterIdEligibilityApiArg = {
  encounterId: string;
};
export type PostV2ProviderEncountersByEncounterIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderEncountersByEncounterIdEligibilityApiArg = {
  encounterId: string;
};
export type PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiArg =
  {
    encounterId: string;
    manualUpdateRequest: ManualUpdateRequest;
  };
export type GetV2ProviderPatientsByPatientIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type GetV2ProviderPatientsByPatientIdEligibilityApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityApiArg = {
  patientId: string;
};
export type DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiArg =
  {
    patientId: string;
  };
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiArg =
  {
    patientId: string;
    snoozeAlertsRequest: SnoozeAlertsRequest;
  };
export type GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse =
  /** status 200 OK */ ListResponseVerificationEventResponse;
export type GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg = {
  patientId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
};
export type PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg = {
  patientId: string;
  manualUpdateRequest: ManualUpdateRequest;
};
export type BatchCheckResponse = {
  actions_created: number;
  batch_id: string;
  discovery_actions_created?: number;
  estimated_completion_minutes: number;
  skipped_recently_checked: number;
  total_patients: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type BatchCheckRequest = {
  /** Number of days ahead to look for appointments */
  days_ahead?: number;
  /** Skip patients checked within this many hours */
  staleness_hours?: number;
};
export type BatchProgressResponse = {
  batch_id: string;
  completed: number;
  failed: number;
  pending: number;
  progress_pct: number;
  total: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type BulkCheckResultItem = {
  /** Set when status is success or deduped — points the FE at the snapshot it should refetch / display. */
  eligibility_snapshot_id?: string | null;
  encounter_id?: string | null;
  error_code?: string | null;
  error_message?: string | null;
  patient_id: string;
  /** Effective readiness on the resulting snapshot, when available. Lets the FE update the row badge in place without an extra lookup. */
  readiness?:
    | ("verified" | "collect" | "collected" | "attention" | "blocked" | "info")
    | null;
  status: "success" | "deduped" | "self_pay_skipped" | "failed";
};
export type BulkCheckSummary = {
  deduped: number;
  failed: number;
  self_pay_skipped: number;
  succeeded: number;
  total: number;
};
export type BulkCheckResponse = {
  results: BulkCheckResultItem[];
  summary: BulkCheckSummary;
};
export type BulkCheckTarget = {
  /** When provided, the snapshot is encounter-scoped — used by the worklist's per-row Run button. Omit for a patient-level check. */
  encounter_id?: string | null;
  /** Patient to check. */
  patient_id: string;
};
export type BulkCheckRequest = {
  /** When true, bypass the per-target dedup window and re-run even if a snapshot was just created. Use sparingly — most callers want default dedup so double-clicks don't double-bill. */
  force?: boolean;
  /** Up to 25 targets per call. Larger volumes should split across multiple requests or move to the async scheduled batch. */
  targets: BulkCheckTarget[];
};
export type WorklistItem = {
  action_verb?: string | null;
  coverage_id?: string | null;
  coverage_kind?: string | null;
  duration_minutes?: number | null;
  eligibility_snapshot_id?: string | null;
  encounter_type?: string | null;
  is_self_pay?: boolean;
  is_silenced?: boolean;
  last_verified_at?: string | null;
  lock_expires_at?: string | null;
  lock_set_by?: string | null;
  lock_set_by_name?: string | null;
  member_id_last4?: string | null;
  member_obligation_cents?: number | null;
  next_appointment_at?: string | null;
  next_appointment_id?: string | null;
  next_encounter_id?: string | null;
  patient_id: string;
  patient_name: string;
  payer_name?: string | null;
  provider_license_level?: string | null;
  provider_name?: string | null;
  readiness?:
    | ("verified" | "collect" | "collected" | "attention" | "blocked" | "info")
    | null;
  readiness_label?: string | null;
  silenced_at?: string | null;
  silenced_until?: string | null;
  summary: string;
  task_priority: number;
  verification_method?: string | null;
};
export type SegmentCount = {
  /** Number of items in this segment */
  count: number;
  /** Segment key */
  key: string;
  /** Display label */
  label: string;
  /** Color hint: error, warning, success, or null */
  severity?: string | null;
};
export type WorklistTotals = {
  awaiting_check?: number;
  needs_attention?: number;
  needs_coverage?: number;
  self_pay?: number;
  silenced?: number;
  total_patients_in_window?: number;
  verified?: number;
};
export type WorklistWindow = {
  end: string;
  start: string;
};
export type WorklistResponse = {
  items?: WorklistItem[];
  page?: number;
  per_page?: number;
  segments?: SegmentCount[];
  total?: number;
  total_pages?: number;
  totals: WorklistTotals;
  window: WorklistWindow;
};
export type AlertDetail = {
  code: string;
  description: string;
  severity: "info" | "warning" | "error";
  suggested_action?: string | null;
  title: string;
};
export type BillingInput = {
  last_payment_date?: string | null;
  patient_due_status: string;
  total_charge_cents: number;
  total_paid_cents: number;
};
export type VisitCoverageGap = {
  /** Last day of the gap; null = no later coverage on file */
  end?: string | null;
  /** First day of the gap window */
  start: string;
  /** The date of service evaluated */
  visit_date: string;
};
export type VisitLimitWarning = {
  plan_name: string;
  reason: "managed_medicaid" | "marketplace" | "pattern_match";
};
export type EligibilityCheckResponse = {
  alert_details?: AlertDetail[];
  alerts?: string[];
  billing?: BillingInput | null;
  corrected_member_id?: string | null;
  coverage_status: string;
  eligibility_check_state?: "not_applicable" | "current" | "due";
  eligibility_snapshot_id?: string | null;
  encounter_id?: string | null;
  expires_at?: string | null;
  financials?: {
    [key: string]: any;
  };
  has_coverage?: boolean;
  is_self_pay?: boolean;
  is_silenced?: boolean;
  last_checked_at?: string | null;
  lock_expires_at?: string | null;
  lock_set_by?: string | null;
  lock_set_by_name?: string | null;
  next_action?: string;
  next_action_owner?: string;
  patient_id: string;
  patient_insurance_coverage_id?: string | null;
  payer_name?: string | null;
  pinned_appointment_at?: string | null;
  pinned_appointment_id?: string | null;
  pinned_encounter_id?: string | null;
  plan_status?: string | null;
  readiness?:
    | ("verified" | "collect" | "collected" | "attention" | "blocked" | "info")
    | null;
  readiness_label?: string | null;
  service_tier?: string;
  silenced_at?: string | null;
  silenced_until?: string | null;
  source?: string;
  status: string;
  submitted_member_id?: string | null;
  summary: string;
  verification_contacted_at?: string | null;
  verification_method?: string | null;
  verification_reference_number?: string | null;
  verification_rep_name?: string | null;
  visit_coverage_gap?: VisitCoverageGap | null;
  visit_limit_warning?: VisitLimitWarning | null;
};
export type ManualUpdateRequest = {
  /** New coverage status */
  coverage_status?: string | null;
  /** Financial field overrides (e.g. copayment_cents, deductible_cents). Only include fields being asserted; an explicit null clears the stored value. member_obligation_cents is re-derived when copay/coinsurance change unless set or cleared explicitly. */
  financials?: {
    [key: string]: any;
  } | null;
  /** Verification method (portal or phone) */
  method?: string | null;
  /** Next action (none/portal_review/phone_verify/block) */
  next_action?: string | null;
  /** Next action owner (provider/biller/system) */
  next_action_owner?: string | null;
  /** Additional notes */
  notes?: string | null;
  /** Reason for the manual override */
  reason?: string | null;
  /** New status (eligible/needs_review/blocked) */
  status?: string | null;
  /** Updated summary text */
  summary?: string | null;
  /** When the call/portal action happened. May predate this request if the user is logging the verification after the fact. */
  verification_contacted_at?: string | null;
  /** Call/ticket reference number from the payer */
  verification_reference_number?: string | null;
  /** Payer rep name from the verification call */
  verification_rep_name?: string | null;
};
export type SnoozeAlertsRequest = {
  /** Datetime at which the snooze expires. Must be in the future and include a timezone offset — naive datetimes are rejected at validation so the service-layer comparison can't TypeError. */
  snooze_until: string;
};
export type VerificationEventResponse = {
  changes?: {
    [key: string]: any;
  } | null;
  coverage_status: string;
  created_at?: string | null;
  eligibility_snapshot_id?: string | null;
  encounter_id?: string | null;
  financials?: {
    [key: string]: any;
  };
  notes?: string | null;
  patient_id: string;
  patient_insurance_coverage_id?: string | null;
  reason?: string | null;
  status: string;
  summary: string;
  user_id?: string | null;
  user_name?: string | null;
  verification_contacted_at?: string | null;
  verification_method?: string | null;
  verification_reference_number?: string | null;
  verification_rep_name?: string | null;
};
export type ListResponseVerificationEventResponse = {
  items: VerificationEventResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
